{
  "common": {
    "login": "iniciar sesión",
    "error": "An error occurred",
    "goHome": "ir inicio",
    "loading": "cargando..."
  },
  "pages": {
    "login": {
      "pageTitle": "iniciar sesión"
    },
    "notFound": {
      "message": "página no encontrada",
      "title": "ups"
    },
    "dashboard": {
      "title": "Widget Items",
      "createButton": "nuevo Widget Item",
      "noData": "no items encontrada",
      "columns": {
        "name": "nombre",
        "description": "descripción",
        "status": "estado",
        "createdOn": "creado On"
      },
      "status": {
        "active": "activo",
        "inactive": "inactivo"
      },
      "createTitle": "Create Widget Item",
      "form": {
        "name": "nombre",
        "description": "descripción",
        "isActive": "activo",
        "nameRequired": "nombre is obligatorio."
      }
    }
  }
}
